import { render } from "./OutpostSetting.vue?vue&type=template&id=6d8c3bd5&scoped=true"
import script from "./OutpostSetting.vue?vue&type=script&lang=js"
export * from "./OutpostSetting.vue?vue&type=script&lang=js"

import "./OutpostSetting.vue?vue&type=style&index=0&id=6d8c3bd5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8c3bd5"]])

export default __exports__